import React from 'react';
import Select from '../form/select';
import LocalizedStrings from '../../localization/strings';

export default function genderSelection(props) {
    const {field} = props;
    return (<Select clearable={false} options={[
        {
            id: 'male',
            name: LocalizedStrings.male
        }, {
            id: 'female',
            name: LocalizedStrings.female
        }
    ]} noResultsText={LocalizedStrings.selectGender} placeholder={LocalizedStrings.gender} {...field} onChange={(item)=>field.onChange(item.value)}/>)

}



// WEBPACK FOOTER //
// ./src/js/components/form/gender-field.js